import categoryMappings from './helpers/expert-category-mappings.json';

import { ExpertCategoryPage } from '../../types';
import { MetaDataContext } from './types';

type Props = {
  data: {
    expertCategoryPage: ExpertCategoryPage;
  };
};

const expertGuide = ({ data }: Props, { t }: MetaDataContext) => {
  if (!data || !data.expertCategoryPage) {
    return {};
  }

  const { category } = data.expertCategoryPage || {};

  if (!category?.name) return {};

  return {
    description: t('meta', 'expert.category-description', {
      category:
        categoryMappings.singular[category.name] ||
        category?.name.toLowerCase(),
    }),
    title: t('meta', 'expert.category-title', {
      category:
        categoryMappings.singularDeterminates[category?.name] ||
        category?.name.toLowerCase(),
      year: new Date().getFullYear(),
    }),
    canonical: category.fullUrl,
    openGraph: undefined,
    structuredData: undefined,
  };
};

export default expertGuide;
